import { render } from "./ContentPreviewMeasure.vue?vue&type=template&id=0a360214&scoped=true"
import script from "./ContentPreviewMeasure.vue?vue&type=script&lang=js"
export * from "./ContentPreviewMeasure.vue?vue&type=script&lang=js"

import "./ContentPreviewMeasure.vue?vue&type=style&index=0&id=0a360214&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a360214"]])

export default __exports__